import React, { useState, useEffect } from 'react'
import { Container, Col, Image, Row, Card } from "react-bootstrap";
import {  useParams } from 'react-router-dom';
import { IPUrl } from "../../commons/IPAddress";
import AllHeader from '../../components/AllHeader';
import { toast } from "react-toastify";
import axiosInstance from '../../api/axiosInstance';

function InternalProjects() {
    const params = useParams();
    const [Id, setId] = useState(params.requestId);
    const [seenFile, setSeenFile] = useState([]);

    useEffect(() => {
            axiosInstance.post("GetPro", {
                Id: Id,
            })
                .then((res) => {
                    if (res.data.result === "true") {
                        setSeenFile(res.data.data)
                    } else {
                        toast.error(res.data.message, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 3000,
                          });
                    }
                });
    }, []);

    return (
        <div>
            <AllHeader>
                <span>پروژه های در حال انجام</span>
            </AllHeader>
            <Container>
                <Row className="justify-content-center">
                    <Col xs={12} md={10} className="rgc-title">
                        <h3>{seenFile.Comments}</h3>
                        <div className='rgc-cards my-3'>
                            <Image variant="top" 
                            height={200} 
                            className="col-12 col-md-5 float-none float-md-start p-3 rounded img-fluid m-0 " 
                            src={IPUrl + "/UploadedFile/Session/Ssn/" + seenFile.Pic} 
                             />
                            <Card.Body>
                                <Card.Title className='d-flex justify-content-between text-primary'>
                                    {seenFile.Tittle}
                                </Card.Title>
                                <hr />
                                <Row className='rgc-cards-list'>
                                    <Col xs={6} className='rgc-cards-list-title'>
                                        <i className='fas fa-calendar-alt'></i>
                                        <span>تاریخ شروع</span>
                                    </Col>
                                    <Col xs={6}>
                                        <p>{seenFile.Date_Start}</p>
                                    </Col>
                                    <Col xs={6} className='rgc-cards-list-title'>
                                        <i className='fas fa-calendar-check'></i>
                                        <span>تاریخ پایان</span>
                                    </Col>
                                    <Col xs={6}>
                                        <p>{seenFile.Date_End}</p>
                                    </Col>

                                    <Col xs={6} className='rgc-cards-list-title'>
                                        <i className='fas fa-user-cog'></i>
                                        <span>پیمانکار</span>
                                    </Col>
                                    <Col xs={6}>
                                        <p>{seenFile.Contractors}</p>
                                    </Col>

                                    <Col xs={6} className='rgc-cards-list-title'>
                                        <i className='fas fa-user-edit'></i>
                                        <span>ناظر</span>
                                    </Col>
                                    <Col xs={6}>
                                        <p>{seenFile.supervisor}</p>
                                    </Col>

                                    <Col xs={6} className='rgc-cards-list-title'>
                                        <i className='far fa-money-bill-alt'></i>
                                        <span>هزینه اجرا</span>
                                    </Col>
                                    <Col xs={6}>
                                        <p>{seenFile.Cost_Op}</p>
                                    </Col>
                                </Row>
                                <hr />
                                <Card.Text>
                                    <i className='fas fa-pen'></i>
                                    <Card.Text dangerouslySetInnerHTML={{ __html: decodeURIComponent(seenFile.Text).replaceAll("/Content/UserFiles/", `${IPUrl}/Content/UserFiles/`) }}>
                                    </Card.Text>
                                    {/* {seenFile.Text} */}
                                </Card.Text>
                            </Card.Body>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default InternalProjects